import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "w-full rounded-lg border border-[#F0F0F4] p-4",
  "data-testid": "approval-flow-preview"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg text-left font-bold leading-6 tracking-[0.09px] text-textPrimary mb-4" }, " Pré-visualização do fluxo de aprovação ", -1)
const _hoisted_3 = { class: "overflow-x-auto" }
const _hoisted_4 = { class: "flex items-start min-w-max px-2" }
const _hoisted_5 = { class: "flex flex-col items-center gap-1 min-w-[80px]" }
const _hoisted_6 = { class: "w-10 h-10 rounded-full flex items-center justify-center z-10 bg-[#267D92]" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-[14px] text-[#4A4A4A] text-center leading-[1.2] mt-2" }, [
  /*#__PURE__*/_createTextVNode(" Pedido"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Realizado ")
], -1)
const _hoisted_8 = { class: "flex items-center h-10 min-w-[60px] grow" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h-[3px] bg-[#BCBCCD] grow" }, null, -1)
const _hoisted_10 = ["data-testid"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "h-[3px] bg-[#BCBCCD] grow" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "flex items-start pt-2"
}
const _hoisted_13 = { class: "flex flex-col items-center gap-1 min-w-[80px]" }
const _hoisted_14 = { class: "w-10 h-10 rounded-full flex items-center justify-center z-10 bg-[#D32F2F]" }
const _hoisted_15 = { class: "text-[14px] text-[#4A4A4A] text-center leading-[1.2] mt-2" }
const _hoisted_16 = {
  key: 0,
  class: "flex px-2 py-1 items-start gap-[10px] rounded border border-[#9E9EB7] bg-white text-[#16161D] text-center font-['Inter',sans-serif] text-[12px] font-normal leading-[14px] tracking-[0.07px] z-10 mx-4 mt-[8px]"
}
const _hoisted_17 = { class: "w-10 h-10 rounded-full flex items-center justify-center z-10 bg-[#D32F2F]" }
const _hoisted_18 = { class: "text-[14px] text-[#4A4A4A] text-center leading-[1.2] mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center min-w-[60px] grow h-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-[3px] bg-[#BCBCCD] grow" })
], -1)
const _hoisted_20 = { class: "flex flex-col items-center gap-1 min-w-[80px]" }
const _hoisted_21 = { class: "w-10 h-10 rounded-full flex items-center justify-center z-10 bg-[#267D92]" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-[14px] text-[#4A4A4A] text-center leading-[1.2] mt-2" }, [
  /*#__PURE__*/_createTextVNode(" Vaga"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Atualizada ")
], -1)

import { computed } from 'vue'
import { mdiCheckCircle, mdiPlay, mdiAccountCircle } from '@mdi/js'
import {
  LayerOperator,
  VALIDATION_ROLE_LABELS,
  LAYER_OPERATOR_LABELS
} from '@/types/approval-flow.types'
import type { ApprovalLayerDetail } from '@/Network/Types/Responses/ApprovalFlowResponses'

interface Props {
  layers: ApprovalLayerDetail[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalFlowPreview',
  props: {
    layers: {}
  },
  setup(__props: any) {

const props = __props;



const groupedLayers = computed(() => {
  const groups: { isOrGroup: boolean; layers: ApprovalLayerDetail[] }[] = []
  let validationCount = 0

  for (const layer of props.layers) {
    if (layer.operator === LayerOperator.OR) {
      const virtualLayers: ApprovalLayerDetail[] = layer.roles.map((role) => ({
        id: ++validationCount,
        order: layer.order,
        operator: layer.operator,
        roles: [role]
      }))
      if (virtualLayers.length > 0) {
        groups.push({ isOrGroup: true, layers: virtualLayers })
      }
    } else {
      for (const role of layer.roles) {
        groups.push({
          isOrGroup: false,
          layers: [
            {
              id: ++validationCount,
              order: layer.order,
              operator: layer.operator,
              roles: [role]
            }
          ]
        })
      }
    }
  }

  return groups
})

const getGlobalIndex = (layer: ApprovalLayerDetail) => layer.id

function operatorLabelFor(): string {
  return LAYER_OPERATOR_LABELS[LayerOperator.AND]
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_icon, {
              icon: _unref(mdiPlay),
              color: "white",
              size: "20"
            }, null, 8, ["icon"])
          ]),
          _hoisted_7
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedLayers.value, (group, groupIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: groupIndex }, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (groupIndex > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", {
                      class: "flex px-2 py-1 items-start gap-[10px] rounded border border-[#9E9EB7] bg-white text-[#16161D] text-center font-['Inter',sans-serif] text-[12px] font-normal leading-[14px] tracking-[0.07px] z-10 mx-1",
                      "data-testid": `operator-badge-${groupIndex}`
                    }, _toDisplayString(operatorLabelFor()), 9, _hoisted_10),
                    _hoisted_11
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(
              group.isOrGroup
                ? 'flex px-4 py-2 justify-center items-start rounded-lg border border-[#9E9EB7] bg-[#F0F0F4]'
                : 'flex flex-col items-center gap-1 min-w-[80px]'
            )
            }, [
              (group.isOrGroup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.layers, (layer, layerIndex) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: layer.id
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_v_icon, {
                              icon: _unref(mdiCheckCircle),
                              color: "white",
                              size: "22"
                            }, null, 8, ["icon"])
                          ]),
                          _createElementVNode("span", _hoisted_15, " Validação " + _toDisplayString(getGlobalIndex(layer)), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layer.roles, (role) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: role.id,
                              class: "font-['Inter',sans-serif] font-bold text-[14px] text-[#16161D] text-center"
                            }, _toDisplayString(_unref(VALIDATION_ROLE_LABELS)[role.role] ?? role.role), 1))
                          }), 128))
                        ]),
                        (layerIndex < group.layers.length - 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, " OU "))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_v_icon, {
                        icon: _unref(mdiCheckCircle),
                        color: "white",
                        size: "22"
                      }, null, 8, ["icon"])
                    ]),
                    _createElementVNode("span", _hoisted_18, " Validação " + _toDisplayString(getGlobalIndex(group.layers[0])), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.layers[0].roles, (role) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: role.id,
                        class: "font-['Inter',sans-serif] font-bold text-[14px] text-[#16161D] text-center"
                      }, _toDisplayString(_unref(VALIDATION_ROLE_LABELS)[role.role] ?? group.layers[0].roles), 1))
                    }), 128))
                  ], 64))
            ], 2)
          ], 64))
        }), 128)),
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_v_icon, {
              icon: _unref(mdiAccountCircle),
              color: "white",
              size: "22"
            }, null, 8, ["icon"])
          ]),
          _hoisted_22
        ])
      ])
    ])
  ]))
}
}

})